import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useLocations } from "../api/hooks";
import { windowPhrase } from "../lib/rules";
import { useShellPrefix } from "../lib/shell";
import { trackAction } from "../lib/usage-track";
import { Button, PageHeader, Select } from "../components/ui";
import { PreviewResults, PreviewStatus, usePreview } from "../components/PreviewResults";

export function PreviewPage() {
  const { blvdId = "" } = useParams();
  const nav = useNavigate();
  const prefix = useShellPrefix();
  const locations = useLocations();
  const preview = usePreview(blvdId);
  const location = locations.data?.find((l) => l.blvdId === blvdId);
  useEffect(() => { trackAction("preview_opened", blvdId ? { blvdId } : undefined); }, []); // once per mount

  return (
    <>
      <PageHeader title="Preview" subtitle={`What BTB blocks would do over ${windowPhrase(location?.lookaheadDays)}, using the rules that apply. Nothing is changed by running a preview.`}
        actions={<>
          <Select aria-label="Location" className="w-56" value={blvdId} onChange={(e) => { preview.reset(); nav(`${prefix}/locations/${e.target.value}/preview`); }}>
            <option value="">Choose a location</option>
            {(locations.data ?? []).map((l) => <option key={l.blvdId} value={l.blvdId}>{l.name}</option>)}
          </Select>
          <Button onClick={preview.start} disabled={!blvdId || preview.running}>{preview.running ? "Running…" : "Run preview"}</Button>
        </>} />
      <PreviewStatus preview={preview} />
      <PreviewResults result={preview.result} locationName={location?.name} admin={prefix === "/admin"} />
    </>
  );
}
